import React, { useContext, useEffect, useState } from 'react'
import { error, formatDate, getNewToken, getSampleCsvHeadings, ROUTES } from '../../../shared/constants'
import { useHistory } from 'react-router'

import { useDownload } from '../../../hooks/Download/useDownload'
import CustomTableLayout from '../../../components/CustomComponents/CustomTableLayout'
import axios from 'axios'
import urlSearchParams from '../../../components/urlSearchParams'
import { UserContext } from '../../../context api/UserContext'
import { formTokenHeader } from '../../../lib/HeaderHelper'
import { toastMessage } from '../../../shared/AlertPopup'
import { API } from '../../../shared/API'

export default function AuditScores() {
  // const { getAllAuditScore, deleteManyAuditScore, loading, paginate } = useAuditScores()
  const { downloadLoading, getPdfCsvData, pdfCsvData } = useDownload()
  // const { auditScores } = useContext(OtherContext)
  //console.log('auditScores : ', auditScores)
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [cancelToken, setCancelToken] = useState(false)
  const [paginate, setPaginate] = useState(false)
  const [auditScores, setAuditScores] = useState([])
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  useEffect(() => {
    if (cancelToken) {
      setLoading(true)
    }
  }, [cancelToken])
  const getAllAuditScore = (dto = {}) => {
    setLoading(true)
    axios
      .get(API['GET_ALL_AUDITSCORE'](urlSearchParams(dto)), {
        ...header,
        // cancelToken: getNewToken(cancelToken, setCancelToken),
      })
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPaginate(data.paginate)
        setAuditScores(data.data)
      })
      .catch((err) => {
        //console.log('err : ', err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const [searchQuery, setSearchQuery] = useState('')
  const filterAuditScore = auditScores.filter((val) => val && val.store && val.employee)
  const [page, setPage] = React.useState(1)

  const noOfPages = paginate && paginate.totalPage
  useEffect(() => {
    getAllAuditScore({
      page: page,
      limit: 10,
      searchQuery,
    })
  }, [page, searchQuery])

  useEffect(() => {
    getPdfCsvData('GET_ALL_AUDITQUESTION')
  }, [])

  const handleChange = (event, value) => setPage(value)

  let tableBody = []

  if (!loading && filterAuditScore.length > 0) {
    tableBody = filterAuditScore.map((item) => {
      return [
        { value: item.auditCode },
        { value: item.store.storeCode },
        { value: item.store.name },
        { value: `${item.employee.firstName} ${item.employee.lastName}` },
        { value: item.totalAuditScore },
        { value: item.auditScore },
        { value: item.modifiedAuditScore },
        // { type: 'INFO', onClick: () => history.push(`/view-audit-question/${item.auditDate}`) },
      ]
    })
  }
  const sampleHeaders = getSampleCsvHeadings(['storeCode', 'auditQuestionCode', 'answer', 'taskCode'])
  const layoutProps = {
    heading: 'Audit Upload',
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    filename: 'auditScores',
    headers: pdfCsvData.headings,
    data: pdfCsvData.headingValues,
    downloadLoading,
    permissionName: 'AUDIT',
    sampleName: 'sample_auditScore',
    sheetName: 'auditScore',
    tempHeaders: sampleHeaders,
  }

  return (
    <CustomTableLayout
      tableHeadings={['audit code', 'store code', 'store name', 'employee', 'total Score', 'Original Score', 'modified score']}
      loading={loading}
      tableBody={tableBody}
      handlePageChange={handleChange}
      paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
    />
  )
}
